import useTranslation from 'next-translate/useTranslation'

import { InstructionProps } from '@/views/product/ts'

function InstructionCard({ instruction, step }: InstructionProps) {
  const { t } = useTranslation('global')
  const { image, text } = instruction

  return (
    <div className="relative p-8 border-2 2xl:py-12 rounded-2xl border-violet-5">
      <span className="absolute flex items-center justify-center w-10 h-10 text-white rounded-full -top-5 -left-5 bg-violet-200">
        {step}
      </span>
      <div className="flex flex-col items-center space-y-6 md:items-center 2xl:space-y-0 2xl:space-x-8 2xl:flex-row 2sm:items-start">
        <figure className="flex-shrink-0 w-32 h-20">{image}</figure>
        <div className="space-y-2">
          <h5 className="font-medium text-violet-200">{t('step', { step })}</h5>
          <p className="max-w-md text-sm">{t(`products:${text}`)}</p>
        </div>
      </div>
    </div>
  )
}

export default InstructionCard
